export default{
    c1:"暫無任務，請使用點券支付",
    c2:"返回",
}